import { Link } from 'arcway/lib/client'

import { Container } from '#components/container.jsx'
import { Logo } from '#components/logo.jsx'
import { SkipLink } from '#components/skip-link.jsx'
import { Button } from '#components/ui/button.jsx'

export function PublicLayout({ children, editorial = false }) {
  return (
    <div
      className={`flex min-h-svh flex-col bg-background text-foreground ${editorial ? 'public-editorial' : ''}`}
    >
      <SkipLink />
      <header className='border-b border-border/70'>
        <Container className='flex min-h-20 items-center justify-between gap-6 py-4'>
          <Link
            className='rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
            href='/'
          >
            <Logo />
          </Link>
          <nav aria-label='Main navigation' className='flex items-center gap-2'>
            <Button asChild variant='ghost'>
              <Link href='/docs'>Docs</Link>
            </Button>
            <Button asChild>
              <Link href='/account'>Your account</Link>
            </Button>
          </nav>
        </Container>
      </header>
      <main className='flex-1' id='main-content' tabIndex='-1'>
        {children}
      </main>
      <footer className='border-t border-border/70'>
        <Container className='flex flex-col gap-5 py-8 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between'>
          <p>Podcast hosting for independent creators.</p>
          <nav
            aria-label='Footer navigation'
            className='flex flex-wrap gap-x-5 gap-y-2'
          >
            <Link className='hover:text-foreground' href='/'>
              Product
            </Link>
            <Link className='hover:text-foreground' href='/docs'>
              Docs
            </Link>
            <Link className='hover:text-foreground' href='/legal/privacy'>
              Privacy
            </Link>
            <Link className='hover:text-foreground' href='/legal/terms'>
              Terms
            </Link>
          </nav>
        </Container>
      </footer>
    </div>
  )
}
